export default __webpack_public_path__ + "static/media/JAG.a9af48cc.jpeg";